import React, { useEffect, useState } from 'react';
import { XIcon, Download } from 'lucide-react';
const purchases = [{
  name: 'Jennifer M.',
  location: 'Miami, FL'
}, {
  name: 'Michael R.',
  location: 'Austin, TX'
}, {
  name: 'Sarah T.',
  location: 'Denver, CO'
}, {
  name: 'David L.',
  location: 'Seattle, WA'
}, {
  name: 'Linda K.',
  location: 'Phoenix, AZ'
}, {
  name: 'Robert B.',
  location: 'Chicago, IL'
}, {
  name: 'Mary P.',
  location: 'Atlanta, GA'
}, {
  name: 'James W.',
  location: 'Boston, MA'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 18000);
    setTimeout(showPopup, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-192">
          <div className="bg-cream border-2 border-gold shadow-[0_0_20px_rgba(199,169,107,0.4)] rounded-lg p-2.5 pr-8 max-w-[300px] w-full relative overflow-hidden pointer-events-auto" data-id="element-193">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold via-sage to-gold" data-id="element-194"></div>

            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-graphite/50 hover:text-graphite transition-colors" data-id="element-195">
              <XIcon className="w-4 h-4" data-id="element-196" />
            </button>

            <div className="flex items-center gap-3" data-id="element-197">
              <div className="w-10 h-10 rounded-full bg-sage/10 flex items-center justify-center shrink-0 border border-sage/30" data-id="element-198">
                <Download className="w-5 h-5 text-sage" data-id="element-199" />
              </div>
              <div className="leading-tight" data-id="element-200">
                <p className="font-bold text-petrol text-sm font-body" data-id="element-201">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-graphite/80 font-medium" data-id="element-202">
                  from {currentPurchase.location}
                </p>
                <p className="text-xs text-sage font-bold mt-0.5 font-body tracking-tight" data-id="element-203">
                  just purchased FITNESS SENIOR READY™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}